import React, { FC } from "react"
import cls from "classnames"

import { sfxPlay } from "@/assets/audios/sfx"

import styles from "./index.module.scss"

export const Close: FC<{
    onClose: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
    className?: string
}> = ({ onClose, className }) => {
    return (
        <div
            className={cls(styles.close, className)}
            onClick={(e) => {
                onClose(e)
                sfxPlay("back_click")
            }}
        >
            {/* <div className={styles.shadow}></div> */}
            <div className={styles.inner}></div>
        </div>
    )
}
